import RoomIcon from '@mui/icons-material/Room';
import HomeIcon from '@mui/icons-material/Home';
import SettingsPowerIcon from '@mui/icons-material/SettingsPower';
import BuildIcon from '@mui/icons-material/Build';
import HouseIcon from '@mui/icons-material/House';
import LawnLeisureIcon from '@mui/icons-material/Grass';
import WarrantyIcon from '@mui/icons-material//AutoAwesomeMosaic';
import InteriorIcon from '@mui/icons-material/NightShelter';
import FurnitureIcon from '@mui/icons-material/Chair';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import Contact from '@mui/icons-material/Contacts';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import GroupIcon from '@mui/icons-material/Group';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import MapIcon from '@mui/icons-material/Map';
import CampaignIcon from '@mui/icons-material/Campaign';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// routes
import { PATH_SERVICE_PRO } from '../../routes/paths';
// components

// ----------------------------------------------------------------------

const ICONS = {
  account: <AccountCircleIcon />,
  dashboard: <DashboardIcon />,
  location: <RoomIcon />,
  home: <HomeIcon />,
  build: <BuildIcon />,
  appliances: <SettingsPowerIcon />,
  warranties: <InsertDriveFileIcon />,
  exterior: <HouseIcon />,
  interior: <InteriorIcon />,
  lawnLeisure: <LawnLeisureIcon />,
  furniture: <FurnitureIcon />,
  admin: <ManageAccounts />,
  contacts: <Contact />,
  task: <ListAltIcon />,
  warranty: <WarrantyIcon />,
  addressSearch: <TravelExploreIcon />,
  customers: <GroupIcon />,
  inspections: <FactCheckIcon />,
  dispatch: <EventAvailableIcon />,
  plans: <CardMembershipIcon />,
  invoices: <ReceiptLongIcon />,
  crm: <SyncAltIcon />,
  territories: <MapIcon />,
  marketing: <CampaignIcon />,
  pro: <AdminPanelSettingsIcon />
};

const sidebarConfigPro = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'Dashboard',
        path: PATH_SERVICE_PRO.dashboard,
        icon: ICONS.dashboard
      },
      {
        title: 'Address Search',
        path: PATH_SERVICE_PRO.addressSearch,
        icon: ICONS.addressSearch
      },
      {
        title: 'Dispatch',
        path: PATH_SERVICE_PRO.dispatch,
        icon: ICONS.dispatch
      },
      {
        title: 'Customers',
        path: PATH_SERVICE_PRO.customers,
        icon: ICONS.customers
      },
      {
        title: 'Service Plans',
        path: PATH_SERVICE_PRO.plans,
        icon: ICONS.plans
      },
      {
        title: 'Invoices',
        path: PATH_SERVICE_PRO.invoices,
        icon: ICONS.invoices
      },
      {
        title: 'CRM Integrations',
        path: PATH_SERVICE_PRO.crm,
        icon: ICONS.crm
      },
      {
        title: 'Territories',
        path: PATH_SERVICE_PRO.territories,
        icon: ICONS.territories
      },
      {
        // The limited trial (card 70). Sits next to Territories because
        // reserving one is half of what it does.
        title: 'Free Trial',
        path: PATH_SERVICE_PRO.trial,
        icon: ICONS.territories
      },
      {
        title: 'Marketing',
        path: PATH_SERVICE_PRO.marketing,
        icon: ICONS.marketing
      },
      {
        title: 'Campaigns',
        path: PATH_SERVICE_PRO.campaigns,
        icon: ICONS.marketing
      },
      {
        title: 'Inspections',
        path: PATH_SERVICE_PRO.inspections,
        icon: ICONS.inspections
      },
      // 'Suggested Outreach' nav item removed — no route exists yet; the outreach
      // engine is tracked on Service Pro card 33. Re-add here once that page ships.
      {
        title: 'Pro',
        path: PATH_SERVICE_PRO.pro.company,
        icon: ICONS.pro,
        children: [
          { title: 'Company', path: PATH_SERVICE_PRO.pro.company },
          { title: 'Users', path: PATH_SERVICE_PRO.pro.users }
        ]
      },
      {
        title: 'Admin',
        path: PATH_SERVICE_PRO.admin.companyType,
        icon: ICONS.admin,
        children: [
          { title: 'Company', path: PATH_SERVICE_PRO.admin.listCompany },
          { title: 'Master Company Type', path: PATH_SERVICE_PRO.admin.companyType }
        ]
      }
    ]
  }
];

export default sidebarConfigPro;
